import React from 'react';
import barsIcon from '../../../assets/img/bars.svg';
import { Box } from '@mui/material';

const Loader = () => {
  return (
    <Box
      sx={{
        m: 0,
        p: 0,
        width: '100%',
        height: '30px',
        textAlign: 'center'
      }}>
      <img alt='Loading...' src={barsIcon} style={{ width: '30px' }} />
    </Box>
  );
};

export default Loader;
